export default __webpack_public_path__ + "static/media/heroku.f10aed24.svg";